import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ReportHeader from "../../../../Components/ReportHeader";
import { useGenerateReportMutation } from "../../../../features/Report/reportSlice";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf"; // Import jsPDF
import "jspdf-autotable";
import Papa from "papaparse";
import { saveAs } from "file-saver";

const SubReport3 = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const year = queryParams.get("year");
  const ReportType = queryParams.get("reportType");
  const GrpID = queryParams.get("groupId");
  const rows = Array(7).fill();

  let rowsData = [];

  if (ReportType === "Report_3d_Small") {
    rowsData = [
      {
        African_american_mbe: [
          { label: "Black" },
          { label: "Direct" },
          { label: "" },
          { label: "Subcontracting" },
          { label: "" },
          { label: "Combined" },
          { label: "" },
        ],
      },
      {
        Hispanic_american_mbe: [
          { label: "Hispanic" },
          { label: "Direct" },
          { label: "" },
          { label: "Subcontracting" },
          { label: "" },
          { label: "Combined" },
          { label: "" },
        ],
      },
      {
        Asian_pacific_mbe: [
          { label: "Asian-Pacific" },
          { label: "Direct" },
          { label: "" },
          { label: "Subcontracting" },
          { label: "" },
          { label: "Combined" },
          { label: "" },
        ],
      },
      {
        Native_american_mbe: [
          { label: "Native American" },
          { label: "Direct" },
          { label: "" },
          { label: "Subcontracting" },
          { label: "" },
          { label: "Combined" },
          { label: "" },
        ],
      },
      {
        Other_mbe: [
          { label: "Other" },
          { label: "Direct" },
          { label: "" },
          { label: "Subcontracting" },
          { label: "" },
          { label: "Combined" },
          { label: "" },
        ],
      },
      {
        TotalCorp: [
          {
            label: `${year} Total Corporate  Procurement`,
          },
          {
            label: "",
          },
        ],
      },
      {
        Total: [
          {
            label: `${year} Total MBE  Procurement`,
          },
          {
            label: "",
          },
        ],
      },
    ];
  } else {
    rowsData = [
      {
        African_american_mbe: [
          { label: "Black" },
          { label: "Direct" },
          { label: "" },
          { label: "Subcontracting" },
          { label: "" },
          { label: "Combined" },
          { label: "" },
        ],
      },
      {
        Hispanic_american_mbe: [
          { label: "Hispanic" },
          { label: "Direct" },
          { label: "" },
          { label: "Subcontracting" },
          { label: "" },
          { label: "Combined" },
          { label: "" },
        ],
      },
      {
        Asian_pacific_mbe: [
          { label: "Asian-Pacific" },
          { label: "Direct" },
          { label: "" },
          { label: "Subcontracting" },
          { label: "" },
          { label: "Combined" },
          { label: "" },
        ],
      },
      {
        Native_american_mbe: [
          { label: "Native American" },
          { label: "Direct" },
          { label: "" },
          { label: "Subcontracting" },
          { label: "" },
          { label: "Combined" },
          { label: "" },
        ],
      },
      {
        Other_mbe: [
          { label: "Other" },
          { label: "Direct" },
          { label: "" },
          { label: "Subcontracting" },
          { label: "" },
          { label: "Combined" },
          { label: "" },
        ],
      },
      {
        Total: [
          {
            label: `${year} Total MBE  Procurement`,
          },
          {
            label: "",
          },
        ],
      },
    ];
  }


  const [generateReport, { data: reportData, error, isLoading: reportLoading }] = useGenerateReportMutation();

  console.log("REP", reportData);

  useEffect(() => {
    const handleReportGeneration = async () => {
      try {
        await generateReport({
          year,
          reportType: ReportType,
          groupId: GrpID,
        }).unwrap();
      } catch (err) {
        console.error("Error generating report:", err);
      }
    };
    handleReportGeneration();
  }, [year, ReportType, GrpID, generateReport]);

  if (reportLoading)
    return (
      <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "600", fontSize: "20px" }}>
        Loading...
      </div>
    );
  if (error)
    return (
      <div style={{ height: "100vh", overflow: "auto", display: "flex", justifyContent: "center", alignItems: "center" }} id='modal_body'>
        <div style={{ fontSize: "20px", fontWeight: "600", color: "#000000" }}>No Record Found !</div>
      </div>
    );

  const pdfGenerate = () => {
    const doc = new jsPDF();

    const addHeader = (doc) => {
      doc.setFontSize(16);
      doc.setTextColor(40);
      doc.text(handleTitlevalue(), 14, 10); // Title

      doc.setFontSize(10);
      doc.setTextColor(60);
      doc.text(
        handleTitle(),
        14,
        16,
        { maxWidth: 180 }
      ); // Description (wrapped text)

      doc.setLineWidth(0.5);
      // doc.line(10, 22, 200, 22); // Horizontal line
    };

    // Call the header function for the first page
    addHeader(doc);


    let startY = 28;
    // doc.text(handleTitle(), 14, 10); // Title of the report
    // doc.text(`Year: ${year}`, 14, 20);

    const tableColumn = ["", ...reportData?.data?.reportData?.map((header) => header.CompanyName)];
    const tableRows = [];

    rowsData.forEach((group, groupIndex) => {
      const key = Object.keys(group)[0];
      const rows = group[key];

      rows.forEach((row, rowIndex) => {
        const rowData = [
          row.label,
          ...reportData?.data?.reportData?.map((item, index) =>
            handleDataCase(rowIndex, item, groupIndex)
          ),
        ];
        tableRows.push(rowData);
      });
    });

    doc.autoTable({
      startY: startY,
      head: [tableColumn],
      body: tableRows,
      showHead: "firstPage",
      styles: {
        fontSize: 8, // Adjust font size
        cellPadding: 2, // Add padding to cells
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [233, 248, 255], // Light blue header background
        textColor: "#000", // Black text color
      },
      bodyStyles: {
        textColor: "#1A1A1A",
      },
    });

    doc.save(`table3.pdf`);
  }

  const csvGenerate = () => {
    let csvContent = "";

    const title = handleTitlevalue();
    const description = handleTitle();

    // Append title, description, and an empty row for spacing
    csvContent += `${title}\n`;
    csvContent += `${description}\n\n`; // Extra newline for spacing

    // Prepare the table headers
    const tableColumn = ["", ...reportData?.data?.reportData?.map((header) => header.CompanyName)];
    csvContent += tableColumn.join(",") + "\n"; // Add headers to CSV

    // Prepare the table rows
    rowsData.forEach((group, groupIndex) => {
      const key = Object.keys(group)[0];
      const rows = group[key];

      rows.forEach((row, rowIndex) => {
        const rowData = [
          row.label,
          ...reportData?.data?.reportData?.map((item, index) =>
            // Handle numbers with commas by enclosing in quotes
            `"${handleDataCase(rowIndex, item, groupIndex)}"`
          ),
        ];
        csvContent += rowData.join(",") + "\n"; // Convert row data to CSV format
      });
    });

    // Create a Blob and trigger download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "table.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const xlsxGenerate = () => {

    const title = handleTitlevalue();
    const description = handleTitle();
    // Prepare the table headers
    const tableColumn = ["", ...reportData?.data?.reportData?.map((header) => header.CompanyName)];
    const tableRows = [];

    rowsData.forEach((group, groupIndex) => {
      const key = Object.keys(group)[0];
      const rows = group[key];

      rows.forEach((row, rowIndex) => {
        const rowData = [
          row.label,
          ...reportData?.data?.reportData?.map((item, index) =>
            // Handle numbers with commas or any special cases
            handleDataCase(rowIndex, item, groupIndex)
          ),
        ];
        tableRows.push(rowData);
      });
    });

    // Create a worksheet from the table data
    const ws = XLSX.utils.aoa_to_sheet([
      [title],
      [description],
      [],
      tableColumn,
      ...tableRows]);

    // Create a workbook with the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Save the workbook as an Excel file
    XLSX.writeFile(wb, 'table.xlsx');
  };

  const handleTitlevalue = () => {
    switch (ReportType) {
      case "Report_1a_Large":
        return "Table 1A"
      case "Report_1a_Small":
        return "Table 1B"
      case "Report_1a_CCA":
        return "Table 1C"
      case "Report_2a_TotalSpend":
        return "Table 2A"
      case "Report_2a_Subcontracting":
        return "Table 2B"
      case "Report_3a_Large":
        return "Table 3A"
      case "Report_3b_Small":
        return "Table 3B"
      case "Report_3c_Large":
        return "Table 3C"
      case "Report_3d_Small":
        return "Table 3D"
      case "Report_4a_Large":
        return "Table 4A"
      case "Report_4a_Small":
        return "Table 4B"
      case "Report_5a_DVBE":
        return "Table 5A"
      case "Report_5a_LGBTBE":
        return "Table 5B"
      default:
        return "Table";
    }
  }

  const downloadHandle = (val) => {
    console.log("VL", val);
    if (val === 1) {
      pdfGenerate();
    }
    if (val === 2) {
      xlsxGenerate();
    }
    if (val === 3) {
      csvGenerate();
    }
  };

  const handleData1 = (value, data, key) => {
    switch (value) {
      case 0:
        return data?.African_american_mbe?.[key] || "";
      case 1:
        return data?.Hispanic_american_mbe?.[key] || "";
      case 2:
        return data?.Hispanic_american_mbe?.[key] || "";
      case 3:
        return data?.Hispanic_american_mbe?.[key] || "";
      case 4:
        return data?.Hispanic_american_mbe?.[key] || "";
      default:
        return null;
    }
  };

  const handleTitle = () => {
    if (ReportType === "Report_3b_Small") {
      return "Summary of Small Utilities Ethnic Procurement Results";
    }
    if (ReportType === "Report_3a_Large") {
      return "Summary of Large Utilities Ethnic Procurement Results";
    }
    if (ReportType === "Report_3c_Large") {
      return "Summary of Large Utilities Ethnic Procurement Results";
    }
    if (ReportType === "Report_3d_Small") {
      return "Summary of Small Utilities Ethnic Procurement Results";
    }
  };

  const handleType = (val, data) => {
    if (ReportType === "Report_3d_Small") {
      if (val === 5) return data?.TotalCorporateProcurement;
      else if (val === 6) return data?.TotalMBEProcurement;
      else return "";
    } else {
      if (val === 5) return data?.TotalMBEProcurement;
      else return "";
    }
  };

  const handleDataCase = (value, data, head) => {
    // console.log("VLLLL",value,data,head)
    switch (value) {
      case 0:
        return handleType(head, data);
      case 1:
        return head === 5 || head === 6 ? "100%" : handleData1(head, data, "direct");
      case 2:
        return handleData1(head, data, "directPercentage");
      case 3:
        return handleData1(head, data, "subcontracting");
      case 4:
        return handleData1(head, data, "subcontractingPercentage");
      case 5:
        return handleData1(head, data, "combined");
      case 6:
        return handleData1(head, data, "combinedPercentage");
      default:
        return null;
    }
  };

  return (
    <div>
      <ReportHeader
        handleClick={reportData?.data?.reportData?.length < 1 ? () => { } : downloadHandle}
        title={handleTitle()}
        year={year}
        report={ReportType}
        logo={localStorage.getItem("logo")}
      />

      <div style={{ height: "calc(100vh - 225px)", overflow: "auto" }} id='modal_body'>
        <TableContainer component={Paper} sx={{ marginTop: "0px" }}>
          {/* {console.log(data, "data")} */}
          <Table aria-label='customized table'>
            <TableHead>
              <TableRow>
                <TableCell
                  align='center'
                  style={{
                    background: "#FFF",
                    fontWeight: "600",
                    color: "#000000",
                    fontSize: "14px",
                    letterSpacing: "0.2px",
                    whiteSpace: "nowrap",
                    width:"150px"
                  }}></TableCell>
                {reportData?.data?.reportData?.map((header, id) => (
                  <TableCell
                    key={id}
                    align='center'
                    style={{
                      background: "#E9F8FF",
                      fontWeight: "600",
                      color: "#000000",
                      fontSize: "14px",
                      letterSpacing: "0.2px",
                      whiteSpace: "nowrap",
                    }}>
                    {header.CompanyName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsData.map((group, groupIndex) => {
                // Access the first and only key in the object
                const key = Object.keys(group)[0];
                const rows = group[key];

                return (
                  // Map through the rows for each group
                  rows.map((row, rowIndex) => (
                    <TableRow
                      key={`${key}-${rowIndex}`}
                      sx={{
                        height: "3.229vw",
                      }}>
                      {/* Render the cells for each row */}
                      <TableCell
                        sx={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#1A1A1A",
                          textAlign: rowIndex === 0 ? "left" : "right",
                          border: "1px solid #E6E6E6",
                          backgroundColor: rowIndex === 3 || rowIndex === 4 ? "#F6F6F6" : "transparent",
                        }}>
                        {row.label}
                      </TableCell>
                      {reportData?.data?.reportData?.map((item, index) => {
                        const cellStyle = {
                          fontWeight: groupIndex === 5 || groupIndex === 6 ? "700" : "400",
                          fontSize: "14px",
                          color: "#1A1A1A",
                          textAlign: "center",
                          border: "1px solid #E6E6E6",
                          backgroundColor: rowIndex === 3 || rowIndex === 4 ? "#F6F6F6" : "transparent",
                        };
                        return (
                          <TableCell key={`cell-${groupIndex}-${rowIndex}-${index}`} sx={cellStyle}>
                            {handleDataCase(rowIndex, item, groupIndex)}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
                );
              })}
              {/* {
                                rows.map((itm, ix) => {
                                    return (
                                        <TableRow sx={{
                                            height: "3.229vw",
                                        }}>
                                            {Array(9) // Assuming there are 9 cells in each row
                                                .fill(null)
                                                .map((_, cellIndex) => {
                                                    // Handle cell-specific logic with a switch case
                                                    const cellContent = (() => {
                                                        switch (cellIndex) {
                                                            case 0:
                                                                return handleText(ix, year - 1); // Customize for the first cell
                                                            case 1:
                                                                return handleTextCell2(ix, itm);
                                                            case 2:
                                                                return handleCommonCell2(ix, itm, "MBE");
                                                            case 3:
                                                                return handleCommonCell2(ix, itm, "WBE");
                                                            case 4:
                                                                return handleCommonCell2(ix, itm, "DVBE");
                                                            case 5:
                                                                return handleCommonCell2(ix, itm, "LGBTBE");
                                                            case 6:
                                                                return handleCommonCell2(ix, itm, "PDBE");
                                                            case 7:
                                                                return handleCommonCell2(ix, itm, "OTHER8a");
                                                            case 8:
                                                                return handleCommonCell2(ix, itm, "TotalSupplierDiversity");
                                                            // Add more cases as needed
                                                            default:
                                                                return null; // Default for cells without specific logic
                                                        }
                                                    })();
                                                    // Additional cell styles based on `cellIndex`
                                                    const cellStyle = {
                                                        fontWeight: cellIndex === 0 ? "700" : "400",
                                                        fontSize: "14px",
                                                        color: "#1A1A1A",
                                                        whiteSpace: "nowrap",
                                                        textAlign: ix === 0 && cellIndex === 0 ? "left" : "right",
                                                        border: "1px solid #E6E6E6", // Add border to each cell
                                                        borderTop:
                                                            ix === 0 && cellIndex === 0
                                                                ? "none"
                                                                : "1px solid #E6E6E6", // Remove borderTop only for the first cell of the first row
                                                        backgroundColor:
                                                            ix === 3 || ix === 4 ? "#F6F6F6" : "transparent", // Conditional background color
                                                    };
                                                    return (
                                                        <TableCell sx={cellStyle} key={cellIndex}>
                                                            {cellContent}
                                                        </TableCell>
                                                    );
                                                })}
                                        </TableRow>
                                    )
                                })
                            } */}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default SubReport3;
